import {Splide} from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const sliderReview = document.getElementById("sliderReviews");
if (sliderReview) {
    new Splide(sliderReview, {
        type   : 'loop',
        arrows: true,
        perPage: 1,
        pagination: false,     
        autoplay: false,
        interval: 2500, 
        speed: 2000,
        focus    : 'center',
        gap    : '1rem', 
        breakpoints: {
            1024: {
                perPage: 1,  // Display 2 slides on tablets
            },
            767: {
                perPage: 1,  // Display 1 slide on mobile
            },
        },
    }).mount();
}


const sliderClients = document.getElementById("sliderLogos");
if (sliderClients) {
    new Splide(sliderClients, {
        type   : 'loop',
        arrows: false,
        perPage: 6,
        pagination: false,     
        interval: 2500, 
        speed: 1000,
        gap    : '1rem', 
        breakpoints: {
            1024: {
                perPage: 4,  // Display 2 slides on tablets
            },
            767: {
                perPage: 2,  // Display 1 slide on mobile
            },
        },
    }).mount({  AutoScroll }); 
}

// content js slider
const sliders = document.querySelectorAll(".jsSlider") as NodeListOf<HTMLElement>;

sliders.forEach(element => {
    new Splide(element,
        {
            type   : 'loop',
            arrows: false,
            perPage: 6,
            perMove: 1,
            pagination:false,
            pauseOnHover: false,
            pauseOnFocus: false,
            // autoplay: true,

            // autoScroll: {
            //     speed: 1,
            // },

            autoScroll: {
                // speed: 1,
                pauseOnHover: false,
                pauseOnFocus: false,
            },            

            breakpoints: {
                1024: {
                    perPage: 3,
                },                    
                768: {
                    perPage: 2,
                },
                480: {
                    perPage: 2,
                },     
                           
            }                
        }
    ).mount({  AutoScroll }); 


    // partners slider
    const sliderLeft = document.getElementById("slide-1");
    if (sliderLeft) {
        new Splide(sliderLeft,
            {
                type   : 'loop',
                arrows: false,
                perPage: 6,    
                pagination:false,
                perMove: 1,
                pauseOnHover: false,
                pauseOnFocus: false,
                breakpoints: {
                    1024: {
                        perPage: 3,
                    },                    
                        767: {
                            perPage: 2,
                        },
                }    ,
                autoScroll: {
                    speed: 1,
                  },                                
            }
        ).mount({ AutoScroll }); 
    }      

    // partners slider
    const sliderRight = document.getElementById("slide-2");
    if (sliderRight) {
        new Splide(sliderRight,
            {
                type   : 'loop',
                arrows: false,
                perPage: 6,    
                pagination:false,
                perMove: 1,
                pauseOnHover: false,
                pauseOnFocus: false,
                breakpoints: {
                    1024: {
                        perPage: 3,
                    },                    
                        767: {
                            perPage: 2,
                        },
                }    ,
                autoScroll: {
                    speed: 3,
                  },                                
            }
        ).mount({ AutoScroll }); 
    }  
});

const sliderHero = document.getElementById("sliderHero");
if (sliderHero) {
    new Splide(sliderHero, {
        type   : 'loop',
        arrows: false,
        perPage: 1,
        pagination: true,     
        autoplay: true,
        interval: 2500, 
        speed: 2000,
        // focus    : 'center',
        // gap    : '2rem', 
        breakpoints: {
            1024: {
                perPage: 1,  // Display 2 slides on tablets
            },
            767: {
                perPage: 1,  // Display 1 slide on mobile
            },
        },
    }).mount();
}